import { DataSource } from '@angular/cdk/table';
import { map, Observable } from 'rxjs';
import { GroupsService } from './groups.service';

export class GroupsDataSource extends DataSource<any> {
  constructor(private groupsService: GroupsService) {
    super();
  }

  connect(): Observable<any[]> {
    return this.groupsService.getGroups().pipe(
      map((groups) => {
        return groups
          .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
          .sort((a, b) => {
            return a.year - b.year;
          });
      }),
    );
  }

  override disconnect(): void {
    // throw new Error('Method not implemented.');
  }
}
